import { render, staticRenderFns } from "./ReportEditor.vue?vue&type=template&id=3fba6ce1&scoped=true&"
import script from "./ReportEditor.vue?vue&type=script&lang=js&"
export * from "./ReportEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReportEditor.vue?vue&type=style&index=0&id=3fba6ce1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba6ce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fba6ce1')) {
      api.createRecord('3fba6ce1', component.options)
    } else {
      api.reload('3fba6ce1', component.options)
    }
    module.hot.accept("./ReportEditor.vue?vue&type=template&id=3fba6ce1&scoped=true&", function () {
      api.rerender('3fba6ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/ReportEditor.vue"
export default component.exports